export default __webpack_public_path__ + "images/6557fdd169cc59b1401f93fbc3e2c164-comedy_tablet-2.webp";